import React from 'react'

import { Link } from 'react-router-dom'

import XrayLink from './xray-link'
import { IAcademyArticle } from '../../views/academy'
import AcademyVideoPlayer from '../video-player/academy-video-player'

interface ILinkRendererProps {
  nodeKey: string
  literal: unknown
  href: string
  children: React.ReactNode
  articles: IAcademyArticle[]
}

function getUrl(href: string): URL | null | undefined {
  try {
    return new URL(href, window.location.origin)
  } catch {
    return null
  }
}

export default function LinkRenderer({ nodeKey, literal, ...props }: ILinkRendererProps) {
  if (props.href && props.href.startsWith('dooer:video:') && props.href.endsWith(':embed')) {
    return <AcademyVideoPlayer videoId={props.href.split(':')[2]} />
  }

  if (props.href.startsWith('dooer:xray:') && props.href.endsWith(':reference')) {
    const xrayId = props.href.split(':')[2]

    return <XrayLink {...props} key={nodeKey} xrayId={xrayId} />
  }

  const url = getUrl(props.href)

  return url && url.hostname === window.location.hostname ? (
    <Link
      {...props}
      key={nodeKey}
      style={{ overflowWrap: 'anywhere' }}
      to={
        props.href.startsWith('#academy')
          ? `/hjalp/${props.articles.find((a) => a.id === props.href.split('/')?.[2])?.path || ''}`
          : [url.pathname, url.search, url.hash].join('')
      }
    />
  ) : (
    <a href={props.href} style={{ overflowWrap: 'anywhere' }}>
      {props.children}
    </a>
  )
}
